import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { FaFacebookF, FaLinkedinIn, FaArrowLeft } from 'react-icons/fa';
// Importing the data array from the main list file
import { managementData } from './BoardOfDirectors'; 

const BoardOfDirectorsDetails = () => {
  const { id } = useParams();
  
  // Find the targeted director based on the ID from route parameters
  const member = managementData.find((item) => item.id === parseInt(id));

  // Fallback view if director is not found
  if (!member) {
    return (
      <div style={{ textAlign: 'center', padding: '100px 20px', fontFamily: "'Segoe UI', sans-serif" }}>
        <h2>Director Profile Not Found</h2>
        <p>The profile you are looking for might have been moved or does not exist.</p>
        <Link to="/about-us/board-of-directors" style={{ color: '#c004d4', textDecoration: 'none', fontWeight: '600' }}>
          Back to Board of Directors
        </Link>
      </div>
    );
  }

  return (
    <div style={{ fontFamily: "'Segoe UI', system-ui, sans-serif", background: "#f8fafc", minHeight: "100vh", paddingBottom: "80px" }}>
      
      {/* Top Professional Header Banner */}
      <div style={{ width: "100%", background: "linear-gradient(90deg, #1d72f3 0%, #b000d6 100%)", padding: "60px 20px", color: "#ffffff" }}>
        <div style={{ maxWidth: "1440px", margin: "0 auto", padding: "0 20px" }}>
          <Link 
            to="/about-us/board-of-directors" 
            style={{ display: "inline-flex", alignItems: "center", gap: "8px", color: "rgba(255,255,255,0.9)", textDecoration: "none", fontSize: "14px", fontWeight: "600", marginBottom: "20px", transition: "color 0.2s" }}
            onMouseEnter={(e) => e.target.style.color = "#fff"}
            onMouseLeave={(e) => e.target.style.color = "rgba(255,255,255,0.9)"}
          >
            <FaArrowLeft /> BACK TO DIRECTORS
          </Link>
          <h1 style={{ margin: 0, color: "rgba(255,255,255,0.9)", fontSize: "clamp(28px, 4vw, 38px)", fontWeight: "700" }}>Executive Profile</h1>
        </div>
      </div>

      {/* Main Profile Details Card */}
      <div style={{ maxWidth: "1440px", margin: "-40px auto 0", padding: "0 20px" }}>
        <div style={{ background: "#ffffff", borderRadius: "16px", boxShadow: "0 10px 30px rgba(0, 0, 0, 0.05)", overflow: "hidden", display: "flex", flexDirection: "row", flexWrap: "wrap" }}>
          
          {/* Left Column: Image Area */}
          <div style={{ flex: "1 1", background: "linear-gradient(135deg, #f3e8ff 0%, #fae8ff 100%)", display: "flex", alignItems: "center", justifyContent: "center", position: "relative", minHeight: "400px" }}>
            {member.image ? (
              <img 
                src={member.image} 
                alt={member.name} 
                style={{ width: "100%", height: "100%", objectFit: "cover", position: "absolute", inset: 0 }}
              />
            ) : (
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "10px" }}>
                <svg viewBox="0 0 100 100" width="120" height="120">
                  <circle cx="50" cy="35" r="20" fill="#cbd5e1" />
                  <ellipse cx="50" cy="85" rx="38" ry="25" fill="#cbd5e1" />
                </svg>
              </div>
            )}
          </div>

          {/* Right Column: Bio & Info Area */}
          <div style={{ flex: "2 1 500px", padding: "50px 40px", display: "flex", flexDirection: "column", justifyContent: "center" }}>
            <span style={{ textTransform: "uppercase", fontSize: "12px", letterSpacing: "2px", fontWeight: "700", color: "#1d72f3", marginBottom: "8px", display: "block" }}>
              Iconic Unity Group Leader
            </span>
            <h2 style={{ margin: "0 0 8px", fontSize: "clamp(26px, 3vw, 36px)", fontWeight: "800", color: "#1a1a2e" }}>
              {member.name}
            </h2>
            <h4 style={{ margin: "0 0 24px", fontSize: "17px", fontWeight: "600", color: "#bd06d3" }}>
              {member.title}
            </h4>

            {/* Divider */}
            <div style={{ width: "60px", height: "4px", background: "linear-gradient(90deg, #1d72f3, #b000d6)", borderRadius: "2px", marginBottom: "24px" }} />

            <p style={{ margin: "0 0 30px", fontSize: "16px", color: "#475569", lineHeight: "1.8", fontWeight: "400" }}>
              {member.description}
            </p>

            {/* Social Connect Options */}
            <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
              <span style={{ fontSize: "14px", fontWeight: "700", color: "#1a1a2e", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                Connect Globally
              </span>
              <div style={{ display: "flex", gap: "12px" }}>
                <a 
                  href={member.socials.facebook} 
                  target="_blank" 
                  rel="noreferrer" 
                  style={{ width: "42px", height: "42px", borderRadius: "50%", background: "#f1f5f9", display: "flex", alignItems: "center", justifyContent: "center", color: "#1d72f3", transition: "all 0.2s" }}
                  onMouseEnter={(e) => { e.currentTarget.style.background = "#1d72f3"; e.currentTarget.style.color = "#fff"; }}
                  onMouseLeave={(e) => { e.currentTarget.style.background = "#f1f5f9"; e.currentTarget.style.color = "#1d72f3"; }}
                >
                  <FaFacebookF size={18} />
                </a>
                <a 
                  href={member.socials.linkedin} 
                  target="_blank" 
                  rel="noreferrer" 
                  style={{ width: "42px", height: "42px", borderRadius: "50%", background: "#f1f5f9", display: "flex", alignItems: "center", justifyContent: "center", color: "#b000d6", transition: "all 0.2s" }}
                  onMouseEnter={(e) => { e.currentTarget.style.background = "#b000d6"; e.currentTarget.style.color = "#fff"; }}
                  onMouseLeave={(e) => { e.currentTarget.style.background = "#f1f5f9"; e.currentTarget.style.color = "#b000d6"; }}
                >
                  <FaLinkedinIn size={18} />
                </a>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default BoardOfDirectorsDetails;